export const PAGE_FILTER_SHORT_NAME = "page"
export const pageDefault = 1

const sN = PAGE_FILTER_SHORT_NAME
const pD = pageDefault

export const PAGE_FILTER_CONFIG = {
  short_name: sN,
  default_values: pD,
  is_default: value => testPageDefault(value), //right before clean up
  format_to_api: value => formatPageForAPI(value), //strip out defaults; put into the correct api form. //IF we have the value using the short code, then let's format it
  format_from_url: value => formatPageFromURL(value) //
}

export const testPageDefault = value => {
  if (value === 1) {
    return true
  } else {
    return false
  }
}

export const formatPageFromURL = value => {
  let cleanValue = null
  if (value) {
    if (!isNaN(value)) {
      cleanValue = value
    }
  }
  return cleanValue
}

export const formatPageForAPI = value => {
  if (value) {
    return { page: value }
  } else {
    return {}
  }
}
